import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", null, [_renderSlot(_ctx.$slots, "nav"), _renderSlot(_ctx.$slots, "content")]);
}